import { render, staticRenderFns } from "./BriefDetails.vue?vue&type=template&id=02a0b0ba&"
import script from "./BriefDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BriefDetails.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a0b0ba')) {
      api.createRecord('02a0b0ba', component.options)
    } else {
      api.reload('02a0b0ba', component.options)
    }
    module.hot.accept("./BriefDetails.vue?vue&type=template&id=02a0b0ba&", function () {
      api.rerender('02a0b0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/components/BriefDetails.vue"
export default component.exports